/** HTML 태그를 제거하고 텍스트만 반환하는 함수 */
function stripHtml(html: string) {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  return tempDiv.textContent || tempDiv.innerText || ''
}

function filterToNumber(value: string) {
  return value.replace(/\D/g, '')
}

function formatPhoneWithHyphen(value: string): string {
  if (value) {
    return value.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
  } else {
    return ''
  }
}

export const Utils = {
  stripHtml,
  filterToNumber,
  formatPhoneWithHyphen,
}

export const getBrowserEnv = (): 'webview' | 'inapp' | 'web' => {
  const INAPP_PATTERN =
    /KAKAOTALK|NAVER\(inapp|NAVER|FBAN|FBAV|FB_IAB|Instagram|Line\/|DaumApps|BAND\/|Twitter|BytedanceWebview/i

  const ua = navigator.userAgent

  if (INAPP_PATTERN.test(ua)) return 'inapp'
  if (/; wv\)|; wv;/.test(ua)) return 'webview'
  return 'web'
}
